import React from 'react';

/*
    GeneralTableColumn component
    @param {Object} style - The style to be applied to the container.
    @param {Object} children - The children to be wrapped.
    @param {Boolean} header - Whether or not the container should be a header.
    @param {Boolean} disabled - Whether or not the container should be disabled.
    @param {Function} onClick - The function to be called when the container is clicked.
    @param {Boolean} noLine - Whether or not the container should have a line.
    @param {Boolean} noMargin - Whether or not the container should have a margin.
    @param {String} padding - The padding to be applied to the container.
    @param {String} lineHeight - The lineHeight to be applied to the container.
    @param {String} textAlign - The textAlign to be applied to the container.
 */
export default function GeneralTableColumn({style, children, header, disabled, onClick, noLine, noMargin, padding, lineHeight, textAlign, colspan}) {

    let templateGridCol = {
        transition: 'all 0.3s ease',
        padding: noMargin ? null : padding ? padding : 10,
        marginBottom: 10,
        borderBottom: noLine ? null : '1px solid #eaeaea',
        fontWeight: header ? 'bold' : null,
        margin:noMargin ? 0 : null,
        whiteSpace:'pre-wrap',
        lineHeight: lineHeight ? lineHeight : '1.6em',
        verticalAlign: 'middle',
        textAlign: textAlign ? textAlign : null,
        gridColumn: colspan ? 'span '+colspan : null,
    };

    if(header) {
        templateGridCol = {
            ...templateGridCol,
            background:'var(--main-01)',
            whiteSpace:'nowrap',
        }
    }

    if(header) return (
        <div style={{...templateGridCol, opacity:disabled ? 0.5 : 1,...style}} onClick={onClick}>
            <div style={{textOverflow:'ellipsis',width:'100%',overflow:'hidden'}}>
                {children}
            </div>
        </div>
    )

    return (
        <div style={{...templateGridCol, opacity:disabled ? 0.5 : 1,...style}} onClick={onClick}>
            {children}
        </div>
    )
}
